
"use strict";

var WPtablist = function (obj) {
    var self;
    /**
     * 
     * @param {*} e 
     */
    var tablist = function (e) {

        //: default
        this.default = {
            version: '1.0.0',
            role: e.id,
            tag: {
                li: $('<li class="kt-nav__item "></li>')
            },
            folder: null
        };

        if (e.data) {
            this.default.data = e.data;
        }
        this.default.ele =this.default.role;
        self = $.extend({}, this.default);

        //init(this);
    }

    let binding = function (the, data, ele) {

        let li;

        if (ele) {
            li = ele;
        } else {
            li = $(`<li id="${the.uuid()}"  class="kt-nav__item " style="padding: 0.5rem 2rem;"></li>`)
        }
     
        if (data.items) {

            if (data.expand) {
                li.addClass('kt-nav__item--sub')
                li.append(the.LinkGroup(data));

                if (data.items.length > 0) {
                    $.map(data.items, function (value, i) {
                        li.find('ul.collapse').append(binding(the, value))
                    })
                }
            } else {
                li.append(the.LiItem(data))
            }
        } else {
            li.append(the.LiItem(data))
        }

        return li;

    }

    tablist.prototype = {
        LinkGroup: function (value) {

            let title = value.name.replace(" ", "")
            return $(`<a class="kt-nav__link" role="tab" id="${title}" data-toggle="collapse" href="#Sub_${title}" aria-expanded="${value.expand}">
                        <i class="kt-nav__link-icon flaticon-symbol"></i>
                        <span class="kt-nav__link-text">${title}</span>
                        <span class="kt-nav__link-arrow"></span>
                    </a> 
                    <ul class="kt-nav__sub collapse " id="Sub_${title}" role="tabpanel" aria-labelledby="Sub_${title}" data-parent="#${title}" style="">
                     </ul>`);
        },
        LiItem: function (value) {

            let code = this.uuid();

            let a = $(`<a class="kt-nav__link" id="${code}" data-folder="${value.name}" >
                                        <i class="kt-nav__link-icon flaticon-symbol"></i>
                                        <span class="kt-nav__link-text">${value.name}</span>
                                    </a>
                            `)
        

            return a;
        },
        loading:function(c,callback) {
           
            let align = self.ele.find(`ul[align="top"]`);
            let the = this

            $.map(c.data, function (value, i) {
           
                let li = $(`<li id="${the.uuid()}"  class="kt-nav__item " ></li>`)
                align.append(binding(the, value, li))
            });

           
             align.find('li').first().find('ul.collapse').addClass('show');
    
          
        //    li.find('li[id].kt-nav__item ').first().addClass('active');

            this.event(function(e){});

            callback(self);

            let li = self.ele.find('li[id]');
            
            if (li.find('active').length == 0) {
                if (c.active) {
                    li.first().find('ul [data-folder="' + c.folder + '"]').parent().addClass('active');
                }
              //  li.first().find('ul.collapse li[data-folder="' + c.folder + '"]').addClass('active');
            } else {
                li.removeClass('active');
            }

        },
        event: function (callback) {
            
            let ele = self.ele.find(`ul[align="top"] [id][data-folder]`);

            let li = self.ele.find('ul[align]')    

            ele.click(function(e){

               li.find('li.kt-nav__item.active').removeClass('active');

                // li.removeClass('active');
               $(this).parent().addClass('active');

                callback({
                    event:$(this),
                    element:self
                });
            })
           
        },
        uuid: function (param) {
            var d = new Date().getTime();
            var d2 = (performance && performance.now && (performance.now() * 1000)) || 0; //Time in microseconds since page-load or 0 if unsupported
            var uuid = 'xxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16;
                if (d > 0) {
                    var r = (d + r) % 16 | 0;
                    d = Math.floor(d / 16);
                } else {
                    var r = (d2 + r) % 16 | 0;
                    d2 = Math.floor(d2 / 16);
                }
                return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
            });
            return uuid;
        }
    }


    return new tablist(obj);
}
